import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: lubiwei
 * @LastEditors: wangshengqiang
 * @Description: 具备空中签名按钮的导航栏，华润经代项目接入横琴传世一号时追加的组件，在代理人告知页配置使用
 */
import React, { useState, useReducer, useRef } from 'react';
import { Button, Loading, Popup, Picker, Cell } from 'zarm';
import { fetchClick } from '@/components/Button';
import { getFetchBaseData } from '@/utils/utils'; // import jsbridge from '@/utils/jsBridge';

import imageWxShare from '@/assets/images/wxShare.png';
import './index.less';
import { getState } from '@/store';
const initVisibleState = {
  popBottom: false,
  popTop: false,
  popLeft: false,
  popRight: false,
  picker: false,
  popSpec: false,
  popCenterSpec: false
};

const NavBarWithAirSignature = () => {
  const [visible, setVisible] = useReducer((state, action) => {
    const {
      type
    } = action;
    return _objectSpread(_objectSpread({}, state), {}, {
      [type]: !state[type]
    });
  }, initVisibleState);

  const toggle = type => setVisible({
    type
  });

  const getNextStep = buttonCode => {
    Loading.show();
    const data = getFetchBaseData();
    data.buttonCode = buttonCode;
    Loading.hide();
    fetchClick(data, (item, next) => {
      const {
        pageAction
      } = item;

      if (pageAction === 'airSignShare') {
        toggle('popBottom');
      }

      return next;
    });
  };

  const onNextBtnClick = () => {
    getNextStep('next_btn_agentnotify_hengqin');
  };

  const onShareBtnClick = () => {
    // toggle('popBottom');
    getNextStep('air_sign_btn_hengqin');
  };

  const shareWxGodFri = () => {
    jsbridge.shareWXForFriend({
      title: '空中签名',
      desc: '',
      link: `${window.location.protocol}//${window.location.host}/airsign/login${window.location.search}`,
      img: ''
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "navBarWithAirSignature-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    className: "nextStep",
    onClick: onNextBtnClick
  }, "\u4E0B\u4E00\u6B65"), /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    className: "onShare",
    onClick: onShareBtnClick
  }, "\u6838\u4FDD\u5E76\u5206\u4EAB"), /*#__PURE__*/React.createElement(Popup, {
    visible: visible.popBottom,
    direction: "bottom",
    onMaskClick: () => toggle('popBottom'),
    afterOpen: () => console.log('打开'),
    afterClose: () => console.log('关闭'),
    destroy: false,
    mountContainer: () => document.body
  }, /*#__PURE__*/React.createElement("div", {
    className: "popupShareBox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shareTitle"
  }, /*#__PURE__*/React.createElement("span", null, "\u5206\u4EAB\u5230"), /*#__PURE__*/React.createElement("span", {
    onClick: () => toggle('popBottom')
  }, "X")), /*#__PURE__*/React.createElement("div", {
    className: "shareImg",
    onClick: shareWxGodFri
  }, /*#__PURE__*/React.createElement("img", {
    src: imageWxShare,
    style: {
      width: '50px'
    },
    alt: ""
  }), /*#__PURE__*/React.createElement("p", null, "\u5FAE\u4FE1\u597D\u53CB")), /*#__PURE__*/React.createElement("div", {
    className: "cancel",
    onClick: () => toggle('popBottom')
  }, "\u53D6\u6D88"))));
};

export default NavBarWithAirSignature;